/** @file liveChord: the chord a binding has right now (overrides applied), looked up by id. */
import { applyOverrides } from '@zilo/pose3d-shortcuts/applyOverrides';
import { liveChordState } from './liveChordState';
import { PLATFORM } from './platform';

/**
 * The effective chord of the first of `ids` that a table binds in one of `contexts` (all contexts when omitted), or
 * undefined (the menu then shows no chord). A rebinding in Settings changes the answer at once.
 */
export function liveChord(ids: readonly string[], contexts?: readonly string[]): string | undefined {
  const effective = liveChordState.tables.flatMap((t) => applyOverrides(t, liveChordState.overrides, PLATFORM).table);
  for (const id of ids) {
    const found = effective.find((b) => b.id === id && (contexts === undefined || contexts.includes(b.context)));
    if (found !== undefined) return found.keys;
  }
  return undefined;
}
